import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import 'tom-select/dist/css/tom-select.css'
import '../stylesheets/tom-select.scss'

export default class extends Controller {
  static targets = ["select"]
  static values = { 
    options: Array,
    placeholder: String
  }

  connect() {
    this.initializeTomSelect()
  }

  disconnect() {
    if (this.tomselect) {
      this.tomselect.destroy()
    }
  }

  initializeTomSelect() {
    if (!this.hasSelectTarget) return

    // Konvertiere HTML-Optionen zu TomSelect-Format (wie Multiple Pools)
    const options = Array.from(this.selectTarget.options).map(option => ({
      id: option.value,
      text: option.text
    }))

    this.tomselect = new TomSelect(this.selectTarget, {
      valueField: 'id',
      labelField: 'text',
      searchField: 'text',
      multiple: true,
      maxItems: null, // Keine Begrenzung der Anzahl auswählbarer Items
      allowEmptyOption: true,
      placeholder: this.placeholderValue || "Optionen auswählen...",
      options: options,
      plugins: {
        'remove_button': {
          title: 'Option entfernen'
        }
      },
      render: {
        option: function(data, escape) {
          return `<div class="flex items-center p-2">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
              ${escape(data.text)}
            </span>
          </div>`;
        },
        item: function(data, escape) {
          return `<div class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
            ${escape(data.text)}
          </div>`;
        }
      }
      // Keine onChange/onBlur Callbacks - das native change Event wird automatisch ausgelöst
      // und von auto-submit Controller verarbeitet (data-action="change->auto-submit#submit")
    })
  }
}

